import React, { useState } from "react";
// import Video from "../../videos/video3.mp4";
import Img from "../../images/vanguardev.png"
import { HeroContainer, HeroBg, ImageBg, ArrowRight, ArrowForward, HeroBtnWrapper, HeroContent, HeroH1, HeroP } from "./HeroElements";
import { ButtonS } from "../ButtonElement";

const HeroSection = ({ title, description }) => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer>
      <HeroBg>
        {/* <VideoBg autoPlay loop muted src={Video} type="video/mp4" /> */}
        <ImageBg src={Img} alt="" />
      </HeroBg>
      <HeroContent>
        <HeroH1>{title}</HeroH1>
        <HeroP>{description}</HeroP>
        <HeroBtnWrapper>
          <ButtonS
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary="true"
            big="true"
            dark="true"
            to="about"
            smooth={true}
            duration={1000}
            spy={true}
            exact="true"
            offset={0}
          >
            Empezar Ahora {hover ? <ArrowForward /> : <ArrowRight />}
          </ButtonS>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
